import { useQuery } from '@tanstack/react-query';

import { announcementQueries } from '../api/announcement';
import useNotificationApiInstance from './useNotificationApiInstance';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { AnnouncementHeartCount } from '../api/announcement';

export interface UseGetAnnouncementHeartCountOptions
  extends Omit<
    UseQueryOptions<AnnouncementHeartCount>,
    keyof ReturnType<typeof announcementQueries.heartCount>
  > {}

/**
 * 새소식의 하트 수를 조회합니다.
 * @description
 * - 하트는 누구나 여러 번 누를 수 있어 값이 자주 바뀌므로 staleTime 을 두지 않습니다.
 */
const useGetAnnouncementHeartCount = (
  announcementId: string,
  options?: UseGetAnnouncementHeartCountOptions,
) => {
  const { endpoint, instance } = useNotificationApiInstance();

  return useQuery({
    ...announcementQueries.heartCount(instance, announcementId),
    enabled: Boolean(endpoint) && Boolean(announcementId),
    ...options,
  });
};

export default useGetAnnouncementHeartCount;
